<template>
  <div class="home">
    <div class="nocustomer">
      <div class="ui-container right aligned">
        <div class="ui right floated header">
          {{ user.name }}
          <h5>{{ user.email }}</h5>
          <button class="ui button red" @click="logout()">
            {{ $t('Disconnect') }}
          </button>
        </div>
      </div>

      <div class="no-customer">
        <button v-if="currentCustomer === null" class="ui basic button orange">
          {{ $t('No customer selected !') }}
        </button>
        <button class="ui basic button green" @click="refreshOrders">
          {{ $t('Refresh') }}
        </button>
        <select
          v-model="locale"
          class="ui fluid dropdown selection"
          style="height: 45px; width: 100px"
        >
          <option value="en">English</option>
          <option value="fr">French</option>
        </select>
      </div>
      <div v-if="pendingOrders.length > 0" id="order-container">
        <div
          v-for="(order, index) in pendingOrders"
          :key="index"
          class="order-item"
        >
          <order-view
            v-model="pendingOrders[index]"
            :active="currentOrder == index"
            @click="toggleOrder(index)"
            home
          ></order-view>
        </div>
        <div class="centered my-2">
          <div
            aria-label="Pagination Navigation"
            role="navigation"
            class="ui pagination menu wide"
          >
            <a
              aria-current="false"
              aria-disabled="false"
              tabindex="0"
              value="1"
              aria-label="First item"
              type="firstItem"
              class="item"
              @click=";(currentOrderPage = 1) && getOrders()"
              >«</a
            >
            <a
              aria-current="false"
              aria-disabled="false"
              tabindex="0"
              value
              aria-label="Previous item"
              type="prevItem"
              class="item"
              @click="currentOrderPage-- && getOrders()"
              >⟨</a
            >
            <a
              aria-current="true"
              aria-disabled="false"
              tabindex="0"
              value="currentOrderPage"
              type="pageItem"
              class="item"
              @click=";(currentOrderPage = 1) && getOrders()"
              >1</a
            >
            <a
              aria-current="false"
              aria-disabled="true"
              tabindex="-1"
              value
              type="ellipsisItem"
              class="item"
              >...</a
            >
            <a
              aria-current="false"
              aria-disabled="false"
              tabindex="0"
              value="currentOrderPage"
              type="pageItem"
              class="item"
              @click=";(currentOrderPage = lastOrderPage) && getOrders()"
              >{{ lastOrderPage }}</a
            >
            <a
              aria-current="false"
              aria-disabled="false"
              tabindex="0"
              value
              aria-label="Next item"
              type="nextItem"
              class="item"
              @click="currentOrderPage++ && getOrders()"
              >⟩</a
            >
            <a
              aria-current="false"
              aria-disabled="false"
              tabindex="0"
              value
              aria-label="Last item"
              type="lastItem"
              class="item"
              @click=";(currentOrderPage = lastOrderPage) && getOrders()"
              >»</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#order-container {
  padding-top: 100px;
}

.no-customer {
  display: flex;
  justify-content: flex-start;
}

.centered {
  text-align: center;
}

.my-2 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      locale: localStorage.getItem('locale') || 'fr',
      pendingOrders: [],
      currentTab: 0,
      currentOrderPage: 1,
      lastOrderPage: 0,
      order: null,
      currentOrder: null
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer',
      user: 'getUser'
    })
  },
  mounted() {
    this.getOrders()
  },
  methods: {
    getOrders() {
      this.currentOrderPage =
        this.currentOrderPage <= 0 ? 1 : this.currentOrderPage
      if (this.currentCustomer == null) {
        axios.get(`/orders?page=${this.currentOrderPage}`).then((response) => {
          this.pendingOrders = response.data.orders
          this.lastOrderPage = parseInt(response.data.total_page / 10, 10)
        })
      }
    },
    logout() {
      this.$store.dispatch('logout')
    },
    toggleOrder(index) {
      if (index === this.currentOrder) {
        this.currentOrder = null
        return
      }
      this.currentOrder = index
    },
    refreshOrders() {
      this.getOrders()
    }
  },
  watch:{
    locale(val){
      this.$i18n.locale = val
      localStorage.setItem('locale', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?0040fc73